import { dictionariesApi } from '@/api'
import { Models } from '@/constants/dictionary'
import _ from 'lodash'

const api = {
  auditoryNumber: 'getAuditoryNumber',
  dayName: 'getDayName',
  departmentName: 'getDepartmentName',
  groupTypeName: 'getGroupTypeName',
  lectorName: 'getLectorName',
  locationAddress: 'getLocationAddress',
  pairTime: 'getPairTime',
  studyGroup: 'getStudyGroup',
  subgroup: 'getSubgroup',
  subjectName: 'getSubjectName',
  weekNumber: 'getWeekNumber',
  lessonType: 'getLessonType',
  groupStream: 'getGroupStream',
  speciality: 'getSpeciality',
  courseNumber: 'getCourseNumber',
  academicYear: 'getAcademicYear',
  semester: 'getSemester',
  pivotField: 'getPivotField'
}

export default {
  namespaced: true,

  state: {
    auditoryNumber: [],
    dayName: [],
    departmentName: [],
    groupTypeName: [],
    lectorName: [],
    locationAddress: [],
    pairTime: [],
    groupStream: [],
    studyGroup: [],
    subgroup: [],
    subjectName: [],
    weekNumber: [],
    lessonType: [],
    speciality: [],
    courseNumber: [],
    academicYear: [],
    semester: [],
    pivotField: []
  },

  getters: {},

  mutations: {
    setDirectory(state, payload) {
      if (payload.model === Models.dayName) {
        const dayOrder = ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс']
        payload.data.sort((a, b) => dayOrder.indexOf(a.name) - dayOrder.indexOf(b.name))
      }
      state[payload.model] = payload.data
    }
  },

  actions: {
    async getDirectory({ state, commit }, payload) {
      if (_.isEmpty(state[payload])) {
        commit('setDirectory', {
          model: payload,
          data: await dictionariesApi[api[payload]]()
        })
      }
    },

    async getAllDirectory({ dispatch }) {
      const directory = [
        Models.lessonType, Models.academicYear, Models.courseNumber,
        Models.groupStream, Models.speciality, Models.semester
      ]
      for(let item of directory) {
        try {
          await dispatch('getDirectory', item)
        } catch (e) {
          console.log(e)
        }
      }
    }
  }
}
